import React from "react";
import { injectIntl } from "react-intl";
import { Button } from "antd";
import moment from "moment";
import "./RightsManager.css";

// Pin 7 del mockup: sólo existe en memoria del cliente que disparó la
// asignación — no hay endpoint de "última operación de la cuenta" para
// mostrarlo a cualquiera que entre después.
// Sin "Descartar": el aviso ya desaparece solo al aplicar otra cosa, y el botón
// sólo agregaba una decisión más al lado de la única que importa, "Deshacer".
const UndoBanner = ({ operation, onRevert, reverting, intl }) => {
  if (!operation) return null;

  return (
    <div className="rm-undo">
      <span>↺</span>
      <span>
        {intl.formatMessage(
          { id: "rights_manager_undo_text" },
          { count: operation.updated, time: moment(operation.at).fromNow() }
        )}
      </span>
      <div className="rm-grow" />
      <Button size="small" loading={reverting} onClick={() => onRevert(operation.operationId)}>
        {intl.formatMessage({ id: "rights_manager_undo_revert" })}
      </Button>
    </div>
  );
};

export default injectIntl(UndoBanner);
